<template>
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-offset-3 col-md-6">
            <card>
                <div class='content'>
                    <form @submit.prevent.stop='search()'>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Buscar</label>
                                    <input type="text" name='search' v-model.trim="searchValue" class="form-control border-input" placeholder="Nome">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="content">

                    <ul class="list-unstyled team-members">
                        <li v-for='(item,index) in items' :key='`item-${index}`'>
                            <edit-generic :item='item' :labelNome='labelNome' :service='service'></edit-generic>
                        </li>
                    </ul>
                    <pagination :count='count' :limit='limit' :page='page' @changePage='changePage($event)'></pagination>
                </div>
            </card>
        </div>
    </div>
</div>
</template>
<script>
import { Pagination } from '@/components'
import EditGeneric from './EditGeneric.vue'
import OverlayService from '../services/overlay-service'

export default {
  components: {
    Pagination,
    EditGeneric
  },

  data () {
    return {
      searchValue: null,
      items: [],
      count: 0,
      limit: 10, 
      page: 0
    }
  },

  mounted () {
    this.loadContent()
  },

  methods: {
    loadContent () {
      const filter = {
        limit: this.limit,
        page: this.page + 1,
        search: this.searchValue,
        orderBy: [{ orderBy: this.labelNome, direction: 'asc' }]
      }

      OverlayService.trigger('show', true)

      this.service.getAll(filter, this.searchValue)
        .then(response => response.data)
        .then(
          items => {
            OverlayService.trigger('show', false)
            this.items = items.data
            this.count = items.total
          },
          er => {
            OverlayService.trigger('show', false)
            this.$alertify.error('Erro ao recuperar dados')
          }
        )
    },

    changePage (page) {
      this.page = page
      this.loadContent()
    },

    search () {
      this.page = 0
      this.loadContent()
    }
  },

  props: {
    service: Object,
    labelNome: String
  }
}
</script>

